import { Spin } from 'antd';
import { CalendarChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

type Data = Array<[string, number]>;

function CalendarWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'calendar', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <CalendarChart data={data ?? []} />;
}

export const calendarWidgetDef: WidgetDefinition = {
  type: 'calendar',
  name: 'Calendar Heatmap',
  description: 'Time-based activity',
  icon: 'CalendarOutlined',
  category: 'chart',
  defaultTitle: 'Calendar',
  defaultConfig: {},
  minW: 5, minH: 4, defaultW: 7, defaultH: 5,
  component: CalendarWidget,
  settingsSchema: { fields: [] },
};
